import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import {
  type GeoRestrictedToken,
  type TradeGeoStatus,
  getTradeGeoStatus,
} from '@/lib/geo/tokenRestrictions';

export const geoCheckQueryKey = () => ['geo-check'] as const;

/** Fetches the user's country and shares it through the query cache. */
export const useGeoCheck = () =>
  useQuery({
    queryKey: geoCheckQueryKey(),
    queryFn: async () => {
      const res = await fetch('/api/geo-check');
      if (!res.ok) throw new Error(`Geo check failed: ${res.statusText}`);
      const data = (await res.json()) as { country: string };
      return data;
    },
    refetchOnReconnect: false,
  });

export const useTradeGeoStatus = (
  buyToken?: GeoRestrictedToken,
  sellToken?: GeoRestrictedToken,
): TradeGeoStatus => {
  const { data } = useGeoCheck();
  const country = data?.country;

  return useMemo(
    () => getTradeGeoStatus([buyToken, sellToken], country),
    [buyToken, country, sellToken],
  );
};
